import type { Theme } from '@mui/material';

export const styles = {
  tableRow: (theme: Theme) => ({
    ':hover': {
      cursor: 'pointer',
      backgroundColor: theme.colors.neutral[100],
    },
  }),

  survey: (theme: Theme) => ({
    display: 'inline-flex',
    color: theme.colors.primary[600],
    fontWeight: 600,
    width: '100%',
  }),

  dueDateWarning: (theme: Theme) => ({
    color: theme.colors.error[500],
    fontWeight: 700,
  }),
};
